<div class="login-form-card">
  <div class="d-flex justify-content-center">
    <h2>Verify OTP</h2>
    <!-- Close button is intentionally removed as we want the user to complete the OTP verification -->
    <!-- <button class="btn-close" matDialogClose></button> -->
  </div>
  <p class="otp-message">
    We’ve sent an OTP to <span>{{ email }}</span> <br />
    Enter below
  </p>
  <div class="otp-input-container">
    <input
      type="text"
      *ngFor="let _ of [0, 1, 2, 3, 4, 5]; let i = index"
      maxlength="1"
      class="otp-input"
      (input)="onInput($event, i)"
      (keydown)="onKeyDown($event, i)"
      (paste)="onPaste($event)"
      pattern="[0-9]*"
      inputmode="numeric"
      [attr.data-index]="i"
      #otpInput
    />
  </div>
  <div class="timer-resend">
    <p class="timer">Time remaining: {{ timer }} seconds</p>
    <button class="resend-btn" [disabled]="timer > 0" (click)="resendOTP()">Resend</button>
  </div>
  <div class="flex flex-col gap-2">
    <app-common-button
      text="Verify"
      variant="primary"
      [disabled]="!isOtpValid()"
      (onClick)="verifyOTP()"
    ></app-common-button>
    <app-common-button
      text="Go back"
      variant="ghost"
      (onClick)="matDialogClose()"
    ></app-common-button>
  </div>
  <!-- <button class="btn w-100" matDialogClose>Go back</button> -->
</div>
